const getMeta = require('./getMeta');

const rmBase = getMeta('rm-base', '')
	.replace(/\/$/, '');

const rmBaseTemplate = getMeta('rm-base-template', '')
	.replace(/\/$/, '');

function parseRmUrl(uri, system_url) {
	return new URL(`${getBase(system_url)}/${uri.replace(/^\//, '')}`, window.location.href);
}

function getBase(system_url) {
	if (!system_url) return rmBase;
	return rmBaseTemplate.replace('||system_name||', system_url);
}

module.exports = parseRmUrl;
parseRmUrl.getBase = getBase;
